import { createAsyncThunk } from '@reduxjs/toolkit';
import { RotateImageDocumentSignalRResponse } from '@v2/components/imageHandling/types/types';
import { AppDispatch } from '@store/types';
import { pushMessage } from '@reducers/v2/messagesBus/messagesBus.slice';
import { RotateImageDocumentMessageHandlerPayload } from '@reducers/v2/imageHandlingV2/messageHandlers';
import { ImageDocumentMessageType } from '@reducers/v2/messagesBus/types';

export const rotateImageDocumentMessageProducer = createAsyncThunk<void, RotateImageDocumentSignalRResponse, { dispatch: AppDispatch }>(
  'imageHandlingV2/rotateImageDocumentMessageProducer',
  async (params, { dispatch }) => {
    const isCropped = params.isCroppedVersion;

    const messagePayload: RotateImageDocumentMessageHandlerPayload = {
      documentId: params.documentId,
      rotationAngle: (isCropped ? params.cropSettings?.rotationAngle : params.pageDetails.rotationAngle) ?? 0,
      isCroppedVersion: isCropped,
      pageNumber: (isCropped ? params.cropSettings?.pageNumber : params.pageDetails.pageNumber) ?? 1,
      cropSettings: params.cropSettings,
    };
    //TODO: handle error
    if (!params.isError) {
      dispatch(
        pushMessage({
          key: params.documentId,
          message: {
            messageType: ImageDocumentMessageType.IMAGE_ROTATED,
            payload: messagePayload,
          },
        })
      );
    }
  }
);
